import api from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./dragula.css";

var options = {"injectType":"styleTag"};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};